import type {
  ConjointAttribute,
  ConjointProfile,
  ConjointTask,
} from "../types";

// One transcript line per pick, e.g. "Chose: Price: $12; Storage: 50GB", or
// "Chose: None of these" when chosenProfileIndex is -1.
export const CONJOINT_NONE_LABEL = "None of these";

// "Price: $12" per level, so a yes/no level such as "Free shipping: Yes" still
// says what it is.
export const formatConjointProfileParts = (
  profile: ConjointProfile,
  attributes: ConjointAttribute[]
): string[] => {
  const attrNameById = new Map(attributes.map((a) => [a.id, a.name]));
  const levelTextById = new Map(
    attributes.flatMap((a) => a.levels.map((l) => [l.id, l.text] as const))
  );
  return profile.levels.map((lvl) => {
    const name = attrNameById.get(lvl.attributeId) ?? "";
    const text = levelTextById.get(lvl.levelId) ?? "";
    return name ? `${name}: ${text}` : text;
  });
};

export const formatConjointAnswer = ({
  task,
  chosenProfileIndex,
  attributes,
}: {
  task: ConjointTask;
  chosenProfileIndex: number;
  attributes: ConjointAttribute[];
}): string => {
  if (chosenProfileIndex < 0) return `Chose: ${CONJOINT_NONE_LABEL}`;

  const profile = task.profiles[chosenProfileIndex];
  if (!profile) return `Chose: ${CONJOINT_NONE_LABEL}`;

  return `Chose: ${formatConjointProfileParts(profile, attributes).join("; ")}`;
};
